import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variables-intelligence-evolution',
  templateUrl: './select-variables-intelligence-evolution.component.html',
  styleUrls: ['./select-variables-intelligence-evolution.component.scss']
})
export class SelectVariablesIntelligenceEvolutionComponent implements  OnDestroy {

  public items: any[] = [
    { name: 'Precio de Venta', value: 'selling_price' },
    { name: 'Ranking', value: 'ranking' },
    { name: 'Dif Precio', value: 'diff_selling_price' },
    { name: 'Margen TAR', value: 'margin_tar' }
  ];

  public variableSelected: any = [];
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableSelected$ = sharedService.sharedVariableEvolution.subscribe((variableSelected: string) => {
      this.variableSelected = variableSelected;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    // ngx-select may return the value directly or in an array
    let value = event;
    if (Array.isArray(event) && event.length > 0) {
      value = event[0];
    }
    if (value && typeof value === 'object' && value.value !== undefined) {
      value = value.value;
    }
    
    this.variableSelected = value;
    this.sharedService.nextVariableEvolution = this.variableSelected;
  }

  isSelected(option: any): boolean {
    if (!this.variableSelected || 
        (Array.isArray(this.variableSelected) && this.variableSelected.length === 0) ||
        this.variableSelected === '' || 
        this.variableSelected === null ||
        this.variableSelected === undefined) {
      return false;
    }
    
    let selectedValue: any;
    if (Array.isArray(this.variableSelected)) {
      if (this.variableSelected.length === 0) {
        return false;
      }
      selectedValue = this.variableSelected[0];
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    } else {
      selectedValue = this.variableSelected;
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    }
    
    return option.value === selectedValue;
  }

}
